import React from "react";
import PublicLayout from "../components/PublicLayout";

export default function About() {
  return (
    <PublicLayout>
      <section className="bg-navy topo-bg">
        <div className="mx-auto max-w-3xl px-5 py-20 lg:px-8">
          <span className="eyebrow text-exploration">About</span>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-white lg:text-5xl">Learning Goes Further Here.</h1>
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-5 py-16 lg:px-8 space-y-6 text-lg leading-relaxed text-slateBrand">
        <p>Homeschool Enrichment Academy connects students with hands-on educational experiences, enrichment opportunities, field trips, creativity, career exploration, and community.</p>
        <p>We're a small, growing local organization built on a simple belief: some of the most meaningful learning happens outside the classroom — in museums, wild spaces, studios, and workplaces where curiosity becomes discovery.</p>
        <p>H.E.A. welcomes homeschool families and other students alike. Families may pay privately, and some experiences may also be eligible for education scholarship funds where they qualify.</p>
        <p>As we grow, our commitment stays the same: remove the friction for families, stay organized and trustworthy, and design every experience so a student is excited to belong.</p>
        <div className="rounded-2xl border border-slate-200 bg-white p-8">
          <h3 className="font-display text-xl font-bold text-navy">What we value</h3>
          <ul className="mt-4 space-y-2 text-base">
            <li>• Real-world, hands-on learning</li>
            <li>• Careful, organized operations and clear communication</li>
            <li>• Small-group experiences with credentialed providers</li>
            <li>• A welcoming community for families</li>
          </ul>
        </div>
      </section>
    </PublicLayout>
  );
}
